import React from 'react';
import { Helmet } from 'react-helmet';

const SEOSchema = ({ type, data }) => {
  const getSchema = () => {
    switch (type) {
      case 'organization':
        return {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": data.name,
          "description": data.description,
          "url": data.url,
          "logo": data.logo,
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": data.phone,
            "contactType": "customer service"
          }
        };
      
      case 'webpage':
        return {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": data.title,
          "description": data.description,
          "url": data.url
        };
      
      case 'medicalTest':
        return {
          "@context": "https://schema.org",
          "@type": "MedicalTest",
          "name": data.name,
          "description": data.description,
          "url": data.url
        };
      
      default:
        return null;
    }
  };

  const schema = getSchema();
  
  return schema ? (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  ) : null;
};

export default SEOSchema;